module.exports = __webpack_public_path__ + "static/Corona-Banner-Landing.08562dbe.jpg";